export const ACCESS_TOKEN_KEY = "dotstorming_access_token";
export const REFRESH_TOKEN_KEY = "dotstorming_refresh_token";

export const getStorageValue = async <T>(key: string): Promise<T | null> => {
  const raw = localStorage.getItem(key);
  return raw ? (raw as unknown as T) : null;
};

export const setStorageValues = async (values: Record<string, unknown>) => {
  Object.entries(values).forEach(([key, value]) => {
    if (value === null || typeof value === "undefined") {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, String(value));
    }
  });
};

export const removeStorageKeys = async (keys: string[]) => {
  keys.forEach((key) => localStorage.removeItem(key));
};
